<section id="topics">

  <i class="fas speaker-icon fa-medal text-center"></i>
  <h2 class="section-heading">Topics</h2>
  <h2 class="section-subheading">Below are the topics, but not restricted to</h2>
  <ul class="list-group text-center">
    <li class="list-group-item">Additive manufacturing</li>
	<li class="list-group-item">3D printing</li>
	<li class="list-group-item">Rapid prototyping</li>
	<li class="list-group-item">Ink jet printing</li>
	<li class="list-group-item">Wire arc additive manufacturing</li>
	<li class="list-group-item">Materials for AM</li>
	<li class="list-group-item">Process Design for AM</li>
	<li class="list-group-item">Optimization in AM</li>
	<li class="list-group-item">Characterization of AM materials</li>
	<li class="list-group-item">Post processing of AM components</li>
	<li class="list-group-item">Biomimic AM</li>
	<li class="list-group-item">Biomaterials through AM</li>
	<li class="list-group-item">Biocompatability of AM products</li>
	<li class="list-group-item">Simulations of AM</li>
  </ul>
<br/>
</section>
<style>
	section {
    padding-top: 86px;
    text-align: center;
  }
  i {
    display: block;
    margin: 0 auto;
    font-size: 2rem;
    padding-bottom: 1em;
  }
	h2 {
		text-align: center;
	}
	p {
		text-align: center;
		width: 80%;
		margin: 0 auto;
		font-size: 1.1em;
	}

	@media all and (min-width: 768px) {
	  p {
	    width: 60%;
	  }
	}
	.section-subheading {
		font-size: 1.3rem;
	}
</style>
